module.exports = __webpack_public_path__ + "img/status3.f92d373d.png";